import { ReactNode, useState } from 'react';
import styles from './Cell.module.scss';

export type CellProps = {
  size?: string;
  ellipsis?: boolean;
  children: string | undefined | ReactNode;
  disabled?: boolean;
  selected?: boolean;
  testId?: string;
  noWidth?: boolean;
};

function Cell({ size, ellipsis, children, disabled, selected, testId, noWidth }: CellProps) {
  const [renderedString, setRenderedString] = useState<string>();

  return (
    <div
      style={{ width: `${size ? `${size}rem` : ''}` }}
      className={`
      ${noWidth ? styles.cellNoWidth : styles.cell} ${disabled && styles.disabled} ${styles.ellipsis} ${styles.shadowSpacing}`}
      title={renderedString}
      data-testid={testId}
      data-selected={selected}
      ref={(ref) => setRenderedString(ref?.textContent ?? undefined)}
    >
      {children}
    </div>
  );
}

export default Cell;
